<template>
  <div>
    <div class="lightbox-contents__ttl">パスワード変更</div>
    <div class="add-single-box-input">
      <input type="text" class="form-text-skelton" placeholder="新パスワード" v-model="password">
    </div>
    <div class="lightbox-contents__btn-class">
      <a href="#" class="btn" @click="addClass">変更</a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        password: ""
      }
    },
    methods: {
      addClass(e) {
        e.preventDefault();

        this.$store.dispatch("passwordChange", this.password);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lightbox/PasswordChange.vue